import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SocialPostPreview.st.css.js';
import { FacebookPost, InstagramPost } from './components';
const skinToPostComponentMap = {
    facebook: FacebookPost,
    instagram: InstagramPost,
};
/** SocialPostPreview */
const SocialPostPreview = ({ skin = 'facebook', className, dataHook, caption, media, profileName, profileImageSrc, }) => {
    const PostComponent = skinToPostComponentMap[skin];
    return (React.createElement("div", { "aria-hidden": "true", "data-hook": dataHook, "data-skin": skin, "data-profile": profileImageSrc, className: st(classes.root, {}, className) },
        React.createElement(PostComponent, { profileName, profileImageSrc, caption, media })));
};
SocialPostPreview.displayName = 'SocialPostPreview';
SocialPostPreview.propTypes = {
    profileName: PropTypes.node,
    profileImageSrc: PropTypes.string,
    skin: PropTypes.oneOf(['facebook', 'instagram']),
    caption: PropTypes.node,
    media: PropTypes.node,
    className: PropTypes.string,
    dataHook: PropTypes.string,
};
export default SocialPostPreview;
//# sourceMappingURL=SocialPostPreview.js.map